export interface Point {
  lon: number; // Longitude
  lat: number; // Latitude
}

// Helper function to parse POINT string
export const parsePoint = (pointString: string): Point | null => {
  const match = pointString.match(/POINT \(([-\d.]+) ([-\d.]+)\)/);
  if (match) {
    return {
      lon: parseFloat(match[1]), // Longitude
      lat: parseFloat(match[2]), // Latitude
    };
  }
  return null; // Return null if the format is invalid
};
